import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { FunctionComponent } from 'react';
import { QuestionConfig, QuestionId } from '../../types/GameplayTypes';

type Props = {
	questionId: QuestionId;
	allQuestions: QuestionConfig[];
	onMove: (id: QuestionId, direction: 'up' | 'down') => unknown;
};

export const OrderButtons: FunctionComponent<Props> = (props) => {
	const currentPosition = props.allQuestions.findIndex(q => q.id === props.questionId);

	return <>
		<IconButton
			size="small"
			onClick={() => props.onMove(props.questionId, 'up')}
			disabled={currentPosition <= 0}
			aria-label="Move earlier"
		>
			<ArrowUpward fontSize="small" />
		</IconButton>

		<IconButton
			size="small"
			onClick={() => props.onMove(props.questionId, 'down')}
			disabled={currentPosition >= (props.allQuestions.length - 1)}
			aria-label="Move later"
		>
			<ArrowDownward fontSize="small" />
		</IconButton>
	</>;
};